module.exports = __webpack_public_path__ + "static/media/muli-latin-700.d3703a0d.woff2";